import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MaterialModule } from '../../../material.module';

export interface EditDescriptionDialogData {
  attachmentId: number;
  fileName: string;
  description: string;
}

export interface EditDescriptionDialogResult {
  attachmentId: number;
  description: string;
}

@Component({
  selector: 'app-edit-description-dialog',
  standalone: true,
  imports: [CommonModule, FormsModule, MaterialModule],
  templateUrl: './edit-description-dialog.component.html',
  styleUrls: ['./edit-description-dialog.component.css']
})
export class EditDescriptionDialogComponent {
  description: string;

  constructor(
    public dialogRef: MatDialogRef<EditDescriptionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EditDescriptionDialogData
  ) {
    this.description = data.description ?? '';
  }

  update(): void {
    const result: EditDescriptionDialogResult = {
      attachmentId: this.data.attachmentId,
      description: this.description,
    };
    this.dialogRef.close(result);
  }

  close(): void {
    this.dialogRef.close();
  }
}
